
import { ref, defineComponent } from 'vue';
import { useRoute } from 'vue-router'

/* Stores */
import { useAppStore } from '@/store/app'

/* 组件 */
import { useWatermark } from '@/hooks/useWatermark'
import { DocumentEditor, IConfig } from "@onlyoffice/document-editor-vue"

/* Apis */
import { GetDocConfigApi } from '@/apis/attachment/attachment.api'

export default defineComponent({
    components: { DocumentEditor },
    async setup() {

        const login = useAppStore().getLoginInfo
        const { setWatermark } = useWatermark()

        const { query } = useRoute()

        const configData = await GetDocConfigApi(query.fileId as string, "edit")
        const docJsFile = ref<string>('https://office.voion.com/ds-vpath/')
        const editConfig = ref<IConfig | any>(configData.data)

        const methods: {
            onAppReady: () => void
            onHistoryClosed: () => void
            requestHistory: (events: any, pr: any) => void
            requestHistoryData: (events: any) => void
            requestRestore: (exent: any) => void
        } = {

            requestRestore: async (event: any) => {

                // const editors = window.DocEditor?.instances.docEditor
                // GetDocHistoryApi(query.fileId as string).then((res) => {
                //     const historyList = (res.data || []);

                //     editors.refreshHistory({ history: historyList })
                // })

            },

            onAppReady: () => {

                setWatermark(`${login.user_name}(${login.user_account})`)

            },

            requestHistory: async (events: any, pr: any) => {
                // const editors = window.DocEditor?.instances.docEditor
                // const response = await GetDocHistoryApi(query.fileId as string);
                // const historyList = (response.data || []);

                // editors.refreshHistory({ history: historyList })
            },

            requestHistoryData: (events: any) => {
                // const version = events.data;
                // const editors = window.DocEditor?.instances.docEditor

                // GetReducingApi(query.fileId as string, version).then((res) => {
                //     editors.setHistoryData(res.data[version - 1]);
                // })
            },

            onHistoryClosed: () => {
                document.location.reload();
            }
        }

        return { docJsFile, editConfig, methods }
    },
})

